import { Rating } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Colors, Icons } from 'copyright-clearance-center-common-ui';
import { useState } from 'react';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			height: '1rem'
		},
		icon: {
			height: '1rem',
			padding: '0 0.125rem',
			lineHeight: '1rem',
			'& svg': {
				position: 'relative',
				width: '1rem',
				height: '1rem'
			}
		},
		emptyIcon: {
			fill: Colors.neutral700
		},
		activeIcon: {
			fill: Colors.primary500
		}
	})
);

export interface IRatingWrapperProps {
	onChange?: (newValue: number) => void;
	value?: number;
	length?: number;
	precision?: number;
	readonly?: boolean;
	disabled?: boolean;
	testId?: string;
}

export const RatingWrapper: React.FunctionComponent<IRatingWrapperProps> = ({
	onChange,
	value = 0,
	readonly = false,
	disabled = false,
	length = 5,
	precision = 0.5,
	testId
}) => {
	const classes = useStyles();
	const [activeValue, setActiveValue] = useState(-1);
	const tooltip = activeValue >= 0 ? activeValue : value ?? 0;

	return (
		<div className={classes.root} title={tooltip.toString()} data-test-id={testId || 'rating'}>
			<Rating
				value={value}
				precision={precision}
				icon={
					<span
						className={clsx(classes.activeIcon, classes.icon)}
						data-test-id="rating-star"
						dangerouslySetInnerHTML={{ __html: Icons.StarFilledIcon }}
					/>
				}
				emptyIcon={
					<span
						className={clsx(classes.emptyIcon, classes.icon)}
						data-test-id="rating-star"
						dangerouslySetInnerHTML={{ __html: Icons.StarIcon }}
					/>
				}
				readOnly={readonly}
				max={length}
				disabled={disabled}
				onChange={(_, newValue) => onChange && onChange(newValue ?? 0)}
				onChangeActive={(_, v) => setActiveValue(v)}
			/>
		</div>
	);
};

export default RatingWrapper;
